<template>
  <el-row>
    <el-col :lg="{span:'17'}" :md="{span:'16'}" :sm="{span:'15'}" :xs="{span:'24'}" >
      <img :src="image_auth" class="image-auth"/>
    </el-col>

    <el-col :lg="{span:'6', offset: '1'}" :md="{span:'7', offset: '1'}" :sm="{span:'8', offset: '1'}" :xs="{span:'24'}" class="auth-holder">
      <!-- <el-card v-loading="loading" class="box-card" style="margin-top: 20px;"> -->

        <h3>Reset Password</h3>
        <el-alert
          v-if="error"
          :title="error"
          type="error"
          center
          :closable="false"
          show-icon>
        </el-alert>
        <el-alert
          v-if="sukses"
          :title="sukses"
          type="success"
          center
          :closable="false"
          show-icon>
        </el-alert>
        <el-form class="auth-form" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" size="small" label-position="top" hide-required-asterisk >
          <el-form-item label="Email" prop="email" :error="errorForm.email">
            <el-input v-model="ruleForm.email" @keyup.enter.native.prevent="submitForm('ruleForm')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="loading">Kirim Email</el-button>
          </el-form-item>
        </el-form>
        
      <!-- </el-card> -->
    </el-col>
  </el-row>
</template>

<script>
import {auth} from '../../firebase'

export default {
  data() {
    return {
      ruleForm: {
        email: '',
        password: ''
      },
      error: '',
      sukses: '',
      rules: {
        email: [
          { required: true, message: 'Masukkan email', trigger: 'blur' },
          { type: 'email', message: 'Email tidak valid', trigger: 'blur' },
        ],
        password: [
          { required: true, message: 'Masukkan password', trigger: 'blur' }
        ]
      },
      errorForm: {
        email: '',
        password: ''
      },
      loading: false,
      image_auth: require('../../assets/background-auth.png'),
    }
  },
  methods: {
    submitForm: function (formName) {
      this.loading = true
      this.error = ''
      this.sukses = ''
      this.$refs[formName].validate((valid) => {
        if (valid) {
          auth.sendPasswordResetEmail(this.ruleForm.email)
            .then(() => {
              this.loading = false
              this.sukses = 'link reset password telah dikirim ke email anda'
            })
            .catch((error) => {
              this.loading = false
              this.error = error.message
            })
          
        } else {
          this.loading = false
          return false;
        }
      });
    },
  },
  mounted() {

  }
}
</script>
